
























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { PatientDetailsViewModel, VentSettingModel, VentMode, VentType } from "@/models";
import VentLabel from "./VentLabel.vue";
import VentValue from "./VentValue.vue";
import {
  getVentAlarmSettingFieldDefinitions,
  VentFieldInfo,
  DefaultVentAlarmFields,
  BellavistaVentAlarmFields
} from "./vent-fields";

@Component({
  components: { VentLabel, VentValue }
})
export default class VentMonitor extends Vue {
  @Prop() readonly patient!: PatientDetailsViewModel;

  get fields(): VentFieldInfo<VentSettingModel>[] {
    let fields: Array<keyof VentSettingModel> = [];

    // Bellavista uses a different set of fields than Avea and only shows fields that have a value
    if (this.isBellavistaType) {
      fields = BellavistaVentAlarmFields.filter(f => !!this.settings[f] || this.settings[f] === 0);
    } else {
      fields = this.getAveaFields();
    }

    // Return the field definitions in the same order
    return getVentAlarmSettingFieldDefinitions(fields);
  }

  get settings() {
    return this.patient.ventSetting;
  }

  get ventType() {
    return this.settings?.ventTypeKey;
  }

  get isBellavistaType() {
    return this.ventType === VentType.Bellavista;
  }

  getAveaFields(): Array<keyof VentSettingModel> {
    switch (this.settings.mode) {
      case VentMode.NasalCpap:
        return ["fiO2High", "fiO2Low"];

      case VentMode.NasalCpapImv:
        return ["pPeakHigh"];

      // All non-Nasal CPAP modes use the same alarm settings
      default:
        return DefaultVentAlarmFields;
    }
  }
}
